import React, { useState } from 'react';
import api from 'utils/api-services';
import { Category } from 'types';

interface CategoriesContextProps {
  categories: Category[];
  categoriesError: string;
  areCategoriesLoading: boolean;
}

const initialContext = {
  categories: [],
  categoriesError: '',
  areCategoriesLoading: false,
};

export const CategoriesContext = React.createContext<CategoriesContextProps>(initialContext);

interface CategoriesProps {
  children: React.ReactNode;
}

export function Categories({ children }: CategoriesProps) {
  const [categories, setCategories] = React.useState<Category[]>([]);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  React.useEffect(() => {
    setIsLoading(true);
    api
      .getFaqCategories()
      .then((res) => {
        setCategories(res as Category[]);
        setIsLoading(false);
      })
      .catch(() => {
        setError('something went wrong');
        setIsLoading(false);
        console.error('error categories');
      });
  }, []);

  return (
    <CategoriesContext.Provider
      value={{ categories, categoriesError: error, areCategoriesLoading: isLoading }}
    >
      {children}
    </CategoriesContext.Provider>
  );
}
